export const getCarrier = (sub) => {
  if (sub) {
    if (sub.sprint_status) return 'sprint';
    if (sub.att_status) return 'att';
    if (sub.tracfone_status) return 'tracfone';
    if (sub.simo_status) return 'simo';
    if (sub.quick_status) return 'quick';

    return null;
  }
  return null;
};

export const getPrettyCarrier = (sub) => {
  if (sub) {
    if (sub.sprint_status) return 'Sprint';
    if (sub.att_status) return 'AT&T';
    if (sub.tracfone_status) return 'Tracfone';
    if (sub.simo_status) return 'Simo';
    if (sub.quick_status) return 'Quick';

    return null;
  }
  return null;
};

export default getCarrier;
